export default __webpack_public_path__ + "static/media/draft2.41fe6642.png";